<template>
  <div class="customise-item" style="display: block;">
    <div class="customise-item-details">
      <div class="extra-items-wrapper" :class="toggleRollInto?'rollinto':''">
        <div
          v-if="!toggleRollInto"
          ref="headerImg"
          v-show="product.PhotoUrl"
          :style="getImageStyle()"
          class="modalImage w-100"
        />
        <img v-if="!toggleRollInto" v-show="false" :src="product.PhotoUrl" @error="imgHttpError" />
        <div class="container item-details" :style="getModifiersContainerStyle()">
          <div class="row" v-if="!toggleRollInto">
            <div class="col-12">
              <h3>{{ product.Name }}</h3>
              <p class="s-description" v-html="product.ShortDescription"></p>
            </div>
            <div class="w-100 pt-2 ml-3 d-flex">
              <h3>{{price | formatMoney}}</h3>
              <h3
                v-if="getBasePoints"
                class="ml-2 text-success"
              >({{getBasePoints|formatNumber}} pts)</h3>
            </div>
            <div class="w-100 pb-1 d-flex justify-content-center">
              <button
                :disabled="(quantity <= 1) || cartQuantity > maxItemQuantity"
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                :style="mobileStyles.CommonColorTxt"
                @click="dec"
              >
                <i class="material-icons bigger-material-icons">remove_circle_outline</i>
              </button>
              <span class="d-flex align-items-center">
                <strong v-if="cartQuantity > maxItemQuantity">1</strong>
                <strong v-else>{{ quantity }}</strong>
              </span>
              <button
                :disabled="cartQuantity >= maxItemQuantity"
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                :style="mobileStyles.CommonColorTxt"
                @click="inc"
              >
                <i class="material-icons bigger-material-icons">add_circle_outline</i>
              </button>
            </div>
          </div>
          <div v-show="!toggleRollInto">
            <Modifiers
              @showSubmodifier="customizeSubmodifier"
              :product="product"
              :modifiers="modifiers"
              :is-submodifier="toggleRollInto"
              :modifier-groups-states="ModifierGroupsStates"
            />
            <div v-if="showRollIntoProduct" class="container mb-2">
              <div class="row">
                <a
                  v-if="selectedRollIntoModiefiers.length==0"
                  :style="mobileStyles.roolIntoButton"
                  @click="toggleRollInto=true"
                >
                  <div class="roll-into-items">
                    <div class="roll-item-details">
                      <div class="roll-item-details-name">{{ showRollIntoProduct.Name }}</div>
                    </div>
                    <div
                      v-if="getRollIntoPoints"
                      class="roll-item-point-addtocart"
                    >({{ getRollIntoPoints | formatNumber }} pts)</div>
                    <div
                      :class="(getRollIntoPoints)?'has-point':''"
                      class="roll-item-cost"
                    >{{ showRollIntoProduct.FixedPriceValue | formatMoney }}</div>
                  </div>
                </a>
                <a v-else class="w-100" @click="toggleRollInto=true">
                  <div
                    v-if="selectedRollIntoModiefiers.length>0"
                    :style="mobileStyles.roolIntoButton"
                    class="h-100"
                  >
                    <div class="roll-into-items">
                      <div class="roll-item-details">
                        <div class="roll-item-details-name">{{ showRollIntoProduct.Name }}</div>
                        <ul>
                          <li
                            v-for="md in selectedRollIntoModiefiers"
                            :key="md.ID"
                            :style="mobileStyles.primaryColor"
                          >{{ md.Name }} ({{md.quantity}})</li>
                        </ul>
                      </div>
                      <div
                        v-if="getRollIntoPoints"
                        class="roll-item-point-addtocart selected"
                      >({{ getRollIntoPoints | formatNumber }} pts)</div>
                      <div
                        :class="(getRollIntoPoints)?'has-point':''"
                        class="roll-item-cost"
                      >{{ rollIntoPrice | formatMoney }}</div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="w-100 mb-2" v-show="viewConfig.ShowNotesForItem">
              <div>
                <h4>{{ $t('message.notes') }}</h4>
                <textarea
                  id="notes"
                  maxlength="300"
                  v-model="itemNote"
                  name="notes"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div v-show="toggleRollInto">
            <Modifiers
              v-if="toggleRollInto"
              :price-trigger="showRollIntoProduct"
              @canceled="toggleRollInto=false"
              :product="rollIntoParams.product"
              :modifiers="rollIntoParams.modifiers"
              :product-id="rollIntoParams.productId"
              @updated="selectRollIntoModiefiers"
              :is-submodifier="toggleRollInto"
              :initial-modifiers="rollIntoParams.initModifiers"
              :has-confirm-button="true"
            />
          </div>
        </div>
      </div>
      <footer class="extras-footer" v-if="!toggleRollInto">
        <button
          type="button"
          class="btn btn-cancel"
          @click="closeModalMobile()"
        >{{ $t('message.cancel') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          :style="mobileStyles.btn"
          :disabled="isDisabledAddCards"
          @click="addToCartMobile()"
        >
          <span
            v-if="cartQuantity <= maxItemQuantity"
            style="float:left;"
          >{{ $t('message.addToCart') }}</span>
          <span
            v-if="cartQuantity <= maxItemQuantity"
            style="float:right;margin-right: 2px;"
          >{{ totalPrice | formatMoney }}</span>
          <span v-else style="float:right;">{{ $t('message.maximumQuantityExceeded') }}</span>
        </button>
        <div>
          <ul>
            <li class="color-red" v-for="(msg,index) in checkRule" :key="index">
              <span v-if="msg!== null">{{msg}}</span>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/products/AddToCart.js";
import { $$ } from "../../../sharedscripts/OO_jquery";
import Modifiers from "./Modifiers";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "AddToCartMobile",
  components: { Modifiers },
  props: {
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    product: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    price: {
      type: Number,
      default: 0
    },
    productId: {
      type: Number,
      default: 0
    }
  },
  // watch: {
  //   // ModifierGroupsStates: {
  //   //   handler: function() {
  //   //     this.checkMaximumSelection();
  //   //     this.checkMinimumSelection();
  //   //   },
  //   //   deep: true
  //   // }
  // },
  data() {
    return {
      quantity: 1,
      maxItemQuantity: 20,
      selectedModifiers: [],
      ModifierGroupsStates: [],
      IsModifierRuleValided: false,
      toggleRollInto: false,
      selectedRollIntoModiefiers: [],
      itemNote: "",
      selectedModifierForCustomize: null
    };
  },
  mounted() {
    const bodyScrollLock = require("body-scroll-lock");
    const targetElement = $$(".extra-items-wrapper");
    bodyScrollLock.disableBodyScroll(targetElement[0]);
    // this.initModifiers();
  },

  computed: {
    ...mapGetters([
      "viewConfig",
      "mobileStyles",
      "canshowRollInto",
      "storeMenu"
    ]),
    ...shared.computed,
    showRollIntoProduct() {
      return this.canshowRollInto(
        { ...this.product, quantity: this.quantity },
        this.quantity
      );
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      if (this.selectedModifierForCustomize)
        return {
          product: this.menuCopy.Products[
            this.selectedModifierForCustomize.LinkedProductID
          ],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.selectedModifierForCustomize.LinkedProductID,
          initModifiers: this.selectedModifierForCustomize.selectedSubmodifiers
        };
      else if (this.showRollIntoProduct)
        return {
          product: this.menuCopy.Products[this.showRollIntoProduct.ProductID],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.showRollIntoProduct.ProductID
        };
      else return {};
    },
    rollIntoPrice() {
      var result = 0;
      this.selectedRollIntoModiefiers.forEach(element => {
        result += element.Price;
      });
      return this.showRollIntoProduct
        ? this.showRollIntoProduct.FixedPriceValue
        : 0 + result;
    }
  },
  methods: {
    ...mapMutations(["confirmRollInto"]),
    ...shared.methods,
    getStyle(isChecked) {
      var style = [];
      if (isChecked) {
        style.push(this.mobileStyles.CommonColorBackground);
      } else {
        style.push({
          "background-color": `rgb(255, 255, 255) !important`
        });
      }
      return style;
    },
    getModifiersContainerStyle() {
      var style = [];
      if (this.toggleRollInto) {
        style.push({ height: "calc(100vh - 75px)" });
        style.push({ "overflow-y": "auto" });
        style.push({ "margin-bottom": "50px" });
      }
      return style;
    }
  }
};
</script>

